import {useRouteEntities} from '@aboutyou/router';
import {isProductTileEntities} from '../../../features/ProductTile/isProductTileEntities';
import type {ProductTileEntities} from '../../../features/ProductTile/types';

export const useComputeDefaultState = (skipDefaultState = false) => {
  const entities = useRouteEntities<ProductTileEntities>();

  if (skipDefaultState) {
    return;
  }

  if (isProductTileEntities(entities)) {
    const {brand, product, price} = entities as ProductTileEntities;

    const brandLogo = {
      brand,
      path: '',
    };

    return {
      brandLogo,
      product,
      saleBadges: [],
      price,
      sizePricesV2: {},
    };
  }

  return undefined;
};
